import React, { createContext, useState, useEffect, useContext } from "react";
import { getItem, setItem } from "../utils/safeStorage";

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Read through safeStorage: Safari makes localStorage null when cookies are
  // blocked, and reading it directly here crashed the entire app at mount.
  const [theme, setTheme] = useState(() => getItem("dupont_dark_mode", "light"));

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    setItem("dupont_dark_mode", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeContext;
